module.exports = __webpack_public_path__ + "img/scialari.f895140d.svg";